module.exports = __webpack_public_path__ + "img/icon_master_white.0fc9c0e9.svg";